"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAll = void 0;
const axios_1 = __importDefault(require("../shared/lib/axios"));
async function findAll() {
    const { data } = await axios_1.default.post("/graphql", {
        query: `
        {
            states {
                id
                name
            }
        }
    `,
    });
    return data.data.states;
}
exports.findAll = findAll;
